/**
 * Check if the current page is part of the login flow.
 * Used to prevent triggering re-authentication during initial login.
 */
export const isOnLoginPage = (): boolean =>
  window.location.pathname.includes('/public/log-in') ||
  window.location.pathname.includes('/public/auth/callback')
